export class ResultCache {
    constructor(loadValue) {
        this.cache = new Map();
        this.loadValue = loadValue;
    }
    get(forceReload = false, params, cacheKey = params === null || params === void 0 ? void 0 : params.toString()) {
        if (forceReload || !this.cache.has(cacheKey)) {
            this.cache.set(cacheKey, this.loadValue(params, forceReload));
        }
        return this.cache.get(cacheKey);
    }
    set(value, key) {
        this.cache.set(key, value);
    }
    clear() {
        this.cache.clear();
    }
}
//# sourceMappingURL=cache.js.map
